function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.2,
  cx: 50,
  cy: 50,
  r: 50,
  fill: "#15A9E1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M50 30.4018C47 26.2076 42.089 23.4737 36.539 23.4737C27.4047 23.4737 20 30.8784 20 40.0127C20 43.9835 21.3994 47.6269 23.7318 50.4777L50 82.5263V30.4018Z",
  fill: "#FF3F62"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M50 62.4224V82.5263L59.0594 71.4735V62.4224H50Z",
  fill: "#C61469"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M59.0594 50.5412V41.4818H70.9406V50.5412H76.2162L76.2682 50.4777C78.6006 47.6269 80 43.9835 80 40.0127C80 30.8784 72.5953 23.4737 63.461 23.4737C57.911 23.4737 53 26.2076 50 30.4018V50.5412H59.0594Z",
  fill: "#C61469"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M70.9406 50.5412V41.4818H65V71.4818H70.9406V62.4224H80V50.5412H70.9406Z",
  fill: "#00CCB3"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M65 41.4818H59.0594V50.5412H50V62.4224H59.0594V71.4818H65V41.4818Z",
  fill: "#00EED1"
});

var SvgHearth = function SvgHearth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHearth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hearth.9d721994.svg";
export { ForwardRef as ReactComponent };